import React from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import { useQuery } from 'react-apollo';

import FullScreenLoader from '../../../../../../components/global/FullScreenLoader';
import { ALBUM_SLIDESHOW_MODE } from '../../../../../../constants/albums';
import VideoSlideshowSolicitation from '../../../../../../components/grid/components/VideoSlideshowSolicitation';
import AlbumSlideshowSolicitation from '../../../../../../components/grid/components/AlbumSlideshowSolicitation';
import { AlbumSlideshowForModeCheck } from '../../../../../../graphql/queries/albums';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      albumId: PropTypes.string,
    }),
  }),
};

const SlideshowSolicitationView = ({ match }) => {
  const { albumId } = match.params;
  const { data: { loading, album } = {} } = useQuery(
    AlbumSlideshowForModeCheck,
    {
      variables: {
        id: albumId,
      },
      skip: !albumId,
    },
  );

  if (loading || !album) {
    return <FullScreenLoader />;
  }

  if (album.slideshow.mode === ALBUM_SLIDESHOW_MODE.ALL_VIDEOS) {
    return <VideoSlideshowSolicitation />;
  }

  return <AlbumSlideshowSolicitation />;
};

SlideshowSolicitationView.propTypes = propTypes;

export default compose(withRouter)(SlideshowSolicitationView);
